import { render, staticRenderFns } from "./ui-chart-component.vue?vue&type=template&id=2740727c&scoped=true&"
import script from "./ui-chart-component.vue?vue&type=script&lang=ts&"
export * from "./ui-chart-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-chart-component.vue?vue&type=style&index=0&id=2740727c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2740727c",
  null
  
)

export default component.exports